import { createPromiseAction } from 'redux-saga-promise-actions';
import { Route, RoutePayload, RouteFailure } from 'store/types/routes';

export const getRoute = createPromiseAction('GET_ROUTES', 'GET_ROUTES_SUCCEEDED', 'GET_ROUTES_FAILURE')<
  RoutePayload,
  Array<string>,
  RouteFailure
>();
